// extracted by mini-css-extract-plugin
export default {"avatar":"BaseUserFields_avatar__ckWuU","item":"BaseUserFields_item__Jn4gd"};